import React, { FC } from "react";
import Modal from "repoV2/components/common/Modal/Modal";
import ModalBody from "repoV2/components/common/Modal/ModalBody";
import BrandedOffering from "@Modules/eventPage/components/BrandedCommunityOfferings/components/BrandedCommunityOffering";
import ModalHeader from "repoV2/components/common/Modal/ModalHeader";
import { getDefaultSectionLabelIconWithTitle } from "repoV2/pages/brandedCommunity/utils/defaultSectionLabel";
import { useEventDataOfSelectedEvent } from "@Utils";
import { DEFAULT_SECTIONS } from "repoV2/pages/brandedCommunity/constants/brandedCommunity.constants";
import styles from "./index.module.scss";
import { IOfferningsModalProps } from "./IOfferingsModal";

const OfferningsModal: FC<IOfferningsModalProps> = ({
    open,
    onClose,
    bonusOfferings,
}) => {
    const { eventData } = useEventDataOfSelectedEvent();
    return (
        <Modal
            open={open}
            onClose={onClose}
            classes={{
                paper: styles.root,
                root: styles.zIndex,
            }}
        >
            <div className={styles.root}>
                <ModalHeader showCloseIcon onClose={onClose}>
                    <div className={styles.headerWrapper}>
                        {getDefaultSectionLabelIconWithTitle({
                            listingDetails: eventData,
                            sectionId: DEFAULT_SECTIONS.BONUS_OFFERINGS,
                        })}
                    </div>
                </ModalHeader>

                <ModalBody className={styles.content}>
                    <div className={styles.bodyWrapper}>
                        {bonusOfferings?.map((item: any) => (
                            <BrandedOffering item={item} key={item.uuid} />
                        ))}
                    </div>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default OfferningsModal;
